import { atomWithStorage } from "jotai/utils";

export const favoriteMarketsAtom = atomWithStorage<string[]>(
	"tenbagger:favorite-markets",
	[],
);
